// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2XlDs","content":"styles_content__2KJHL","tableWrap":"styles_tableWrap__DBrz3"};